import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

export const matkaApi = createApi({
  reducerPath: 'matkaApi',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['Matka'],
  endpoints: (builder) => ({
    getMatkaMarkets: builder.query({
      query: ({ filter } = {}) => ({
        url: filter ? `/api/matka/admin/markets` : '/api/matka/admin/markets',
        method: 'GET',
      }),
      providesTags: ['Matka'],
    }),

    getMatkaMarketDetail: builder.query({
      query: (eventId) => ({
        url: `/api/matka/admin/event-pl?eventId=${eventId}`,
        method: 'GET',
      }),
      providesTags: ['Matka'],
    }),

    getMatkaMarketBets: builder.query({
      query: (eventId) => ({
        url: `/api/matka/admin/markets/${eventId}/bets`,
        method: 'GET',
      }),
      providesTags: ['Matka'],
    }),

    getMatkaBets: builder.query({
      query: ({ market, eventId }) => ({
        url: `/api/matka/admin/bets?market=${market}&eventId=${eventId}`,
        method: 'GET',
      }),
      providesTags: ['Matka'],
    }),

    getMatkaAgentReport: builder.query({
      query: ({ eventId, userId, page = 1, limit = 50 }) => {
        let url = `/api/matka/admin/company-report?eventId=${eventId}&page=${page}&limit=${limit}`;
        if (userId) url += `&userId=${userId}`;
        return { url, method: 'GET' };
      },
      providesTags: ['Matka'],
    }),

    cancelMatkaBet: builder.mutation({
      query: (betId) => ({
        url: `/api/matka/admin/cancel-bet`,
        method: 'POST',
        body: { betId },
      }),
      invalidatesTags: ['Matka'],
    }),

    cancelMatkaEvent: builder.mutation({
      query: ({ market, eventId }) => ({
        url: `/api/matka/admin/cancel-event`,
        method: 'POST',
        body: { market, eventId },
      }),
      invalidatesTags: ['Matka'],
    }),

    getMatkaCompletedEvents: builder.query({
      query: ({ market, fromDate, toDate, page = 1, limit = 10 }) => {
        let url = `/api/matka/admin/completed-events?page=${page}&limit=${limit}`;
        if (market)   url += `&market=${market}`;
        if (fromDate) url += `&fromDate=${fromDate}`;
        if (toDate)   url += `&toDate=${toDate}`;
        return { url, method: 'GET' };
      },
      providesTags: ['Matka'],
    }),
  }),
});

export const {
  useGetMatkaMarketsQuery,
  useGetMatkaMarketDetailQuery,
  useGetMatkaMarketBetsQuery,
  useGetMatkaBetsQuery,
  useGetMatkaAgentReportQuery,
  useGetMatkaCompletedEventsQuery,
  useCancelMatkaBetMutation,
  useCancelMatkaEventMutation,
} = matkaApi;
export default matkaApi;
